<div *ngIf="!isCatalogComponent && featureFlagsService.getByEnv('ui', 'catalogSearch')" id="new-theme" class="search-panel" data-testid="search-panel-section-header">
  <div class="search-info">
    <div class="btn-container">
      <dx-button
        id="btn-search"
        stylingMode="text"
        icon="small-search"
        type="normal"
        (onClick)="searchAndRedirect()"
        [elementAttr]="{ 'data-testid': 'search-panel-btn-search' }"
      >
      </dx-button>
    </div>
    <dx-text-box
      id="header-search-text-box"
      placeholder="Search All Listings"
      style="width: 100%; margin-right: 4px"
      [showClearButton]="true"
      [(value)]="searchValue"
      (onValueChanged)="setSearchText()"
      (onEnterKey)="searchAndRedirect()"
      valueChangeEvent="keyup"
      [stylingMode]="'underlined'"
      [inputAttr]="{ 'data-testid': 'search-panel-input-search' }"
    >
    </dx-text-box>
  </div>
</div>

<!-- Catalog Search -->
<div *ngIf="isCatalogComponent" id="new-theme" class="catalog-search-panel" data-testid="search-panel-section-catalog">
  <div class="search-info">
    <div class="catalog-btn-container">
      <dx-button
        id="btn-search"
        stylingMode="text"
        icon="small-search"
        type="normal"
        (onClick)="searchClick()"
        [elementAttr]="{ 'data-testid': 'search-panel-btn-catalog-search' }"
      >
      </dx-button>
    </div>
    <dx-text-box
      id="catalog-search-text-box"
      placeholder="Search Catalog"
      style="width: 100%; margin-right: 4px"
      [showClearButton]="true"
      [(value)]="searchValue"
      (onValueChanged)="setSearchText()"
      (onEnterKey)="searchClick()"
      [stylingMode]="'underlined'"
      [inputAttr]="{ 'data-testid': 'search-panel-input-catalog-search' }"
    >
    </dx-text-box>
  </div>
</div>
